import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import '../helpers/polyfills'

import globalState from '../helpers/globalState'

import Header from '../components/header/header'
import Footer from '../components/footer/footer'

import '../styles/global/style.scss'

import buildLink from '../helpers/linkBuilder'

const transformCategories = (edges, linkFn = node => '#') =>
  edges.filter(edge => edge.node.count > 0).map(edge => ({
    id: edge.node.wordpress_id,
    label: edge.node.name,
    slug: edge.node.slug,
    lang: edge.node.lang,
    count: edge.node.count,
    link: linkFn(edge.node),
  }))

class TemplateWrapper extends React.Component {
  constructor(props) {
    const articleCategories = transformCategories(
      props.data.articleCategories.edges,
      node =>
        buildLink({
          slug: 'post',
          type: 'static',
          lang: node.lang,
          query: {
            filter: node.slug,
          },
        })
    )

    const portfolioCategories = transformCategories(
      props.data.portfolioCategories.edges,
      node =>
        buildLink({
          slug: 'portfolio',
          type: 'static',
          lang: node.lang,
          query: {
            filter: node.slug,
          },
        })
    )

    const menu = {}
    props.data.menu.edges.forEach(({ node }) => {
      menu[node.lang] = node.processedItems
    })

    const languages = props.data.languages.edges.map(({ node }) => node.lang)

    globalState.setState({
      articleCategories,
      portfolioCategories,
      menu,
      languages,
      defaultOpenGraphImage: props.data.options.defaultOGImage,
    })
    super(props)
  }

  onWindowResize() {
    globalState.setState({
      windowWidth: window.innerWidth,
    })
  }

  componentDidMount() {
    const defaultNavigateTo = (window.___gatsbyNavigateTo =
      window.___navigateTo)

    const newNavigateTo = pathname => {
      globalState.setState({
        loading: pathname,
      })
      defaultNavigateTo(pathname)
    }

    window.___navigateTo = newNavigateTo

    this.onWindowResize()
    window.addEventListener('resize', this.onWindowResize, true)
  }
  render() {
    const { children, data } = this.props

    return (
      <div className="content">
        <Helmet
          title="Brandglow"
          // meta={[
          //   { name: 'description', content: 'Sample' },
          //   { name: 'keywords', content: 'sample, something' },
          // ]}
        >
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="/apple-touch-icon.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="/favicon-32x32.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href="/favicon-16x16.png"
          />
          <link rel="manifest" href="/manifest.json" />
          <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#761b4a" />
          <meta name="theme-color" content="#761b4a" />
        </Helmet>
        {children()}
        <Header />
        <Footer options={data.options} />
      </div>
    )
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export const globalQuery = graphql`
  query Global {
    articleCategories: allWordpressCategory {
      edges {
        node {
          wordpress_id
          name
          slug
          count
          lang
        }
      }
    }
    portfolioCategories: allWordpressWpPortfolioCat {
      edges {
        node {
          wordpress_id
          name
          slug
          count
          lang
        }
      }
    }
    menu: allWordpressMppllMenus(filter: { location: { eq: "primary" } }) {
      edges {
        node {
          lang
          processedItems {
            label
            to
            submenu {
              label
              to
            }
          }
        }
      }
    }
    options: wordpressAcfOptions {
      footer_text {
        kolumna
      }
      social_media {
        title
        link
        image {
          localFile {
            childImageSharp {
              original {
                width
              }
              sizes(quality: 85) {
                aspectRatio
                src
                srcWebp
              }
            }
          }
        }
      }
      defaultOGImage: customDefaultOGImage {
        src
        width
        height
      }
    }
    languages: allWordpressMppllLanguages {
      edges {
        node {
          lang: slug
        }
      }
    }
  }
`

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js